import cs from './cs';
import en from './en';
import sk from './sk';
import pl from './pl';
import hu from './hu';


export default {cs, en, sk, pl, hu};
